export default "__VITE_ASSET__d5de77db__"